import { Modal, Upload, Button } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { useState, useEffect } from 'react';
import { NotificationManager } from 'react-notifications';
import { useDispatch } from 'react-redux';
import { createBannerAsync, fetchBannersAsync } from '../../../../redux/slice/banner/bannerSlice'
import Appconfig from '../../../../config/config';

function AddBannerModal({ open, onCancel, currentBanner }) {
    const dispatch = useDispatch();
    const [fileList, setFileList] = useState([]);
    const [loading, setLoading] = useState(false)
    useEffect(() => {
        if (currentBanner) {
        } else {
            setFileList([]);
        }
    }, [currentBanner, open]);

    const handleChange = ({ fileList: newFileList }) => {
        setFileList(newFileList);
    };

    const handleUpload = async () => {
        setLoading(true)
        if (fileList.length === 0) {
            NotificationManager.error('Please select a file first!', '', 1000);
            return;
        }

        const formData = new FormData();
        fileList.forEach((file) => {
            formData.append('file', file.originFileObj);
        });
        formData.append('site_code', Appconfig.sitecodes);

        try {
            await dispatch(createBannerAsync(formData)).unwrap();
            dispatch(fetchBannersAsync(Appconfig.sitecodes));
            NotificationManager.success('Banner uploaded successfully!', '', 1000);
            setLoading(false)
            onCancel();
        } catch (error) {
            NotificationManager.error('Error uploading banner!', '', 1000);
            setLoading(false)
        }
    };

    return (
        <Modal className='password-model relative top-1 lg:top-7 lg:!w-[34vw]'
            footer={[
                <div className='col-span-12 gap-2 flex flex-shrink-0 flex-wrap items-center justify-end p-[1rem] border-t-[1px] border-t-[#dee2e6]'>
                    <button type="button" data-bs-dismiss="modal" aria-label="Close" className="m-[5px] text-[#fff]  bg-[linear-gradient(#022c43,_#18b0c8)] border-[#0d6efd]  font-bold !px-[10px] !py-[5px] !text-[.875rem] rounded-[.375rem]" disabled={loading} onClick={handleUpload}>{currentBanner ? 'Update' : 'Add'}</button>
                    <button type="button" data-bs-dismiss="modal" aria-label="Close" className="bg-[linear-gradient(-180deg,_#b8beca_0%,_#989595_100%)] font-bold !px-[10px] !py-[5px] !text-[.875rem] m-[5px] text-[#212529] text-center no-underline align-middle border-[1px]  border-[transparent] rounded-[.375rem]" onClick={onCancel}>Cancel</button>
                </div >
            ]}
            onCancel={onCancel}
            open={open} >
            <div className='grid grid-cols-12'>
                <div className='col-span-12 px-[6px] py-[5px] font-bold text-[0.875rem] rounded-t-[5px] h-[35px] bg-[linear-gradient(#022c43,_#18b0c8)] text-[#ffffff] flex flex-shrink-0 items-center justify-between'>
                    <h5 className='text-[0.938rem] font-bold mb-0 leading-normal'>{currentBanner ? 'Update Banner' : 'Add Banner'}</h5>
                    <button type="button" onClick={onCancel} >
                        <span className='text-[1.3125rem] font-bold'>×</span>
                    </button>
                </div>
                <div className='col-span-12 !bg-[#ffffff] !text-[#23282c] relative flex-auto p-4'>
                    <div className='grid grid-cols-12 lg:gap-x-6 '>
                        <div className='col-span-12 lg:col-span-6'>
                            <div className='mb-4 !text-[#23282c]'>
                                <Upload
                                    beforeUpload={() => false}
                                    multiple={false}
                                    fileList={fileList}
                                    onChange={handleChange}
                                >
                                    <Button icon={<UploadOutlined />}>Select Image</Button>
                                </Upload>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </Modal>
    );
}

export default AddBannerModal;